<template>
  <div class="home">
    <!-- <el-collapse>
      <el-collapse-item title="点播" name="1">
        <ul>
          <li>
            <router-link to="/dianbo/course/1">课程</router-link>
          </li>
          <li>
            <router-link to="/dianbo/lecturercard/7">讲师名片</router-link>
          </li>
          <li>
            <router-link to="/dianbo/payconfirm">支付确认</router-link>
          </li>
          <li>
            <router-link to="/dianbo/recharge">充值</router-link>
          </li>
          <li>
            <router-link to="/dianbo/rechargeresult">充值成功</router-link>
          </li>
          <li>
            <router-link to="/dianbo/steadpay">家长代付</router-link>
          </li>
          <li>
            <router-link to="/dianbo/liveroom/4129">直播间</router-link>
          </li>
           <li>
            <router-link to="/dianbo/backplay/4128">回放</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="讲座" name="2">
        <ul>
          <li>
            <router-link to="/lecture/index">讲座首页</router-link>
          </li>
          <li>
            <router-link to="/lecture/join/4100">讲座报名</router-link>
          </li>
         
          <li>
            <router-link to="/lecture/lecturelive/4100">讲座直播间</router-link>
          </li>
           <li>
            <router-link to="/lecture/appointment/1">预约咨询</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="高招咨询会" name="3">
        <ul>
          <li>
            <router-link to="/gz-live/index">首页（首页暂时废弃不用）</router-link>
          </li>
          <li>
            <router-link to="/gz-live/liveList">直播列表</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="志愿" name="4">
        <ul>
          <li>
            <router-link to="/zhiyuan/jumptopay">支付跳转</router-link>
          </li>
           <li>
            <router-link to="/zhiyuan/jumptopaytest">支付跳转测试</router-link>
          </li>
          
        </ul>
      </el-collapse-item>
       <el-collapse-item title="2020-百日誓师" name="5">
        <ul>
          <li>
            <router-link to="/pledge-2020/index">首页</router-link>
          </li>
          <li>
            <router-link to="/pledge-2020/pledgelist/19">宣誓团列表</router-link>
          </li>
          <li>
            <router-link to="/pledge-2020/pledgecard/84">宣誓状</router-link>
          </li>
          <li>
            <router-link to="/pledge-2020/pledgesubmit">我要宣誓</router-link>
          </li>
        </ul>     
      </el-collapse-item>
       <el-collapse-item title="车车代言人" name="6">
        <ul>
          <li>
            <router-link to="/gk-spokes/index">车车代言人</router-link>
          </li> 
          <li>
            <router-link to="/gk-recommender/index">车车推荐官</router-link>
          </li> 
        </ul>
      </el-collapse-item>
       <el-collapse-item title="车币" name="7">
        <ul>
          <li>
            <router-link to="/chebi/recharge">充值</router-link>
          </li>
          <li>
            <router-link to="/chebi/jumptopay">跳转支付</router-link>
          </li>
        </ul>     
      </el-collapse-item>
      <el-collapse-item title="专题直播" name="8">
        <ul>
          <li>
            <router-link to="/zhtlive/index">首页列表</router-link>
          </li>
          <li>
            <router-link to="/zhtlive/zhtdetail">专题详情</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="活动" name="9">
        <ul>
          <li>
            <router-link to="/active-collegepic/index">院校图片征集活动</router-link>
          </li>
          <li>
            <router-link to="/active-xbbj/index">送学霸笔记活动</router-link>
          </li>
          <li>
            <router-link to="/active-dzbxbbj/index">电子版学霸笔记售卖活动</router-link>
          </li>
          <li>
            <router-link to="/zxs/rank">自习室排行榜</router-link>
          </li>
          <li>
            <router-link to="/active-gkjxjjh/index">2021高考奖学金计划</router-link>
          </li>
          <li>
            <router-link to="/active-gk100/index">2022高考人必做的100件事</router-link>
          </li>
          <li>
            <router-link to="/active-hj2021/index">2022寒假一起来自习</router-link>
          </li>
          <li>
            <router-link to="/active-zhuaniu/index">春节抓牛，赢学习礼物</router-link>
          </li>
          <li>
            <router-link to="/pledge-2021/index">2021-百日誓师</router-link>
          </li>
          <li>
            <router-link to="/mycollege-ask/index">喊话我的未来大学</router-link>
          </li>
          <li>
            <router-link to="/active-hhxd/detail">航海行动</router-link>
          </li>
          <li>
            <router-link to="/debate-vote/index">辩论型投票</router-link>
          </li>
          <li>
            <router-link to="/active-z-character/index">解锁z时代天赋</router-link>
          </li>
          <li>
            <router-link to="/active-xy2022/index">春节活动-心愿灯</router-link>
          </li>
          <li>
            <router-link to="/active-xklottery/index">学考抽奖</router-link>
          </li>
          <li>
            <router-link to="/active-gradereport/my-list">一模成绩报告</router-link>
          </li>
          <li>
            <router-link to="/active-estimate/index">新 页面</router-link>
          </li>
          <li>
            <router-link to="#">测试</router-link>
          </li>
        </ul>
      </el-collapse-item>
       <el-collapse-item title="app页面" name="10">
        <ul>
          <li>
            <router-link to="/appview/shortcut-guide">添加快捷方式</router-link>
          </li>
          
        </ul>
      </el-collapse-item>
      <el-collapse-item title="认证" name="11">
        <ul>
          <li>
            <router-link to="/verified/1">优质答主认证</router-link>
          </li>
          <li>
            <router-link to="/verified/2">身份认证</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="志愿6.0.0" name="12">
        <ul>
          <li>
            <router-link to="/zy/index">落地页</router-link>
          </li>
          <li>
            <router-link to="/zy/product">志愿服务</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="客服中心" name="13">
        <ul>
          <li>
            <router-link to="/service/index">客服中心</router-link>
          </li>
        </ul>
      </el-collapse-item>
     
      <el-collapse-item title="地图" name="14">
        <ul>
          <li>
            <router-link to="/map/index">地图</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="高招机器人" name="15">
        <ul>
          <li>
            <router-link to="/gz-robot/index">高招答疑</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="同学圈精华集锦" name="16">
        <ul>
          <li>
            <router-link to="/recommend/index">同学圈精华集锦</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="高考直通车会员" name="17">
        <ul>
          <li>
            <router-link to="/gkvip/index">会员支付</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="测试" name="99">
        <ul>
          <li>
            <router-link to="/test/index">测试</router-link>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="2022-百日誓师" name="18">
        <ul>
          <li>
            <router-link to="/pledge-2022/index">首页</router-link>
          </li>
          <li>
            <router-link to="/pledge-2022/pledgelist/19">宣誓团列表</router-link>
          </li>
          <li>
            <router-link to="/pledge-2022/pledgecard/84">宣誓状</router-link>
          </li>
          <li>
            <router-link to="/pledge-2022/pledgesubmit">我要宣誓</router-link>
          </li>
          <li>
            <router-link to="/pledge-2022/lottery">抽奖</router-link>
          </li>
        </ul>     
      </el-collapse-item>
      <el-collapse-item title="模考转换工具" name="19">
        <ul>
          <li>
            <router-link to="/tool-ranking/index">初版工具</router-link>
          </li>
          <li>
            <router-link to="/active-gradereport/index">广东一模成绩报告</router-link>
          </li>
          <li>
            <router-link to="/active-gradereport-fujian/index">福建一模成绩报告</router-link>
          </li>
          <li>
            <router-link to="/active-gradereport-original/index?exam=">报告模板</router-link>
          </li>
        </ul>     
      </el-collapse-item>
    </el-collapse> -->
  </div>
</template>

<script>
export default {
  created() {
    if (process.env.NODE_ENV !== "development") {
      location.href = 'https://www.gaokaozhitongche.com'
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding: 20px 20px;
  li {
    list-style: none;
    margin: 15px 0;
  }
}
.home {
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
}
</style>
